export default function setIcons() {
  const icons = document.querySelector('[data-icons-swiper]');

  if (icons) {
    const pagination = icons.querySelector(".swiper-pagination");

    const swiper = new Swiper(icons, {
      slidesPerView: 1,
      spaceBetween: 16,
      watchOverflow: true,
      speed: 1000,
      breakpoints: {
        768: {
          slidesPerView: 4,
        },
        1440: {
          slidesPerView: 4,
        },
      },
      pagination: {
        el: pagination,
        type: 'bullets',
        clickable: true,
      },
    });
  }
}
